import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const pendingPrStatus = createAsyncThunk('/pendingStatus/pending-pr',
    async (id) => {
        try {
            const myurl = `${V_URL}/prosafe/pending-pr-status/${id}`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                }
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const pendingPrStatusSlice = createSlice({
    name: "pendingStatus",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(pendingPrStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(pendingPrStatus.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(pendingPrStatus.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default pendingPrStatusSlice.reducer;